import './banner.css';
import headerBanner from '../../assets/img/age-co-header-image-no-roundel.png';

function Banner(props) {
  return (
    <>
        <div className="banner" style={{backgroundImage: `url('${headerBanner}')`}}>
            <div className="banner__content">
                <h1>{props.data.title}</h1>
                <h2>{props.data.subtitle}</h2>			
            </div>
        </div>
    </>
  );
}

export default Banner;